export default __webpack_public_path__ + "static/media/close.6087ffd4.svg";